import { combineReducers } from "redux";
import { i18nReducer } from "react-redux-i18n";

import blocks from "./reducers/blocks";
import cursor from "./reducers/cursor";
import dirtyQuestions from "./reducers/dirtyQuestions";
import distributions from "./reducers/distributions";
import history from "./reducers/history";
import meta from "./reducers/meta";
import oplog from './reducers/oplog'
import params from "./reducers/params";
import payload from "./reducers/payload";
import questions from "./reducers/questions";
import responseId from "./reducers/responseId";
import status from "./reducers/status";
import survey from "./reducers/survey";
import user from "./reducers/user";
import userErrors from "./reducers/userErrors";
import version from "./reducers/version";

const rootReducer = combineReducers({
  blocks,
  cursor,
  dirtyQuestions,
  distributions,
  history,
  meta,
  oplog,
  params,
  payload,
  questions,
  responseId,
  status,
  survey,
  user,
  userErrors,
  version,
  i18n: i18nReducer,
});

export default rootReducer;
